import { FC, useState, ChangeEvent } from 'react';
import { useStyles } from './styles';
import { Grid, Paper, Tabs, Tab } from '@material-ui/core';
import TabPanel from 'components/TabPanel';
import EndUserKeyMangement from 'components/Forms/EndUserKeyMangement';
import { OdicTable } from 'components/Tables/OdicTable';
import ThirdPartyTable from '../SAMLTable/ThirdPartyTable';
import SamlTable from 'components/Tables/SAMLTable/SamlTable';
// import ProviderTable from 'components/Tables/SAMLTable/ProviderTable';
function a11yProps(index: string) {
  return {
    id: `wrapped-tab-${index}`,
    'aria-controls': `wrapped-tabpanel-${index}`,
  };
}

export const AccessManagementTable: FC = () => {
  const classes = useStyles();
  const [value, setValue] = useState<string>('one');
  const handleChange = (event: ChangeEvent<unknown>, newValue: string) => {
    setValue(newValue);
  };

  return (
    <Grid item xl className={classes.tabsPanel}>
      <Paper className={classes.tabsPaper}>
        <div className={classes.tabsContainer}>
          <Tabs
            value={value}
            className={classes.tabs}
            TabIndicatorProps={{ style: { color: 'transparent', background: 'transparent' } }}
            onChange={handleChange}
            variant='scrollable'
            scrollButtons='auto'
          >
            {/* <Tab value='one' wrapped label='SAML IdP' {...a11yProps('three')} className={classes.label} /> */}
            <Tab value='one' wrapped label='SAML IdP' {...a11yProps('one')} className={classes.label} />
             <Tab value='two' wrapped label='SAML SP' {...a11yProps('two')} className={classes.label} />
            <Tab value='three' wrapped label='OIDC' {...a11yProps('three')} className={classes.label} />
            <Tab value='four' wrapped label='Rest-API' {...a11yProps('four')} className={classes.label} />
          </Tabs>
        </div>
        <div>

          <TabPanel value={value} index='one'>
            <SamlTable />
          </TabPanel>
           <TabPanel value={value} index='two'>
            <ThirdPartyTable />
          </TabPanel>
          <TabPanel value={value} index='three'>
            <OdicTable />
          </TabPanel>
          <TabPanel value={value} index='four'>
            <EndUserKeyMangement />
          </TabPanel>
        </div>
      </Paper>
    </Grid>
  );
};
